import { useNavigate } from 'react-router-dom';
import accountIcon from '@web/utils/src/assets/icons/functions/account-icon.svg';
import { HeaderCartButton } from '@/components/HeaderCartButton';
import { Logo } from '../Logo';

const MobileNavigation = () => {
  const navigate = useNavigate();

  return (
    <nav
      id="mobile-nav"
      className="flex md:hidden h-14-0 w-full justify-between items-center container bg-primary-white shadow-sm relative"
    >
      <div className="space-y-0-5" onClick={() => navigate('/')}>
        <span className="block w-4-0 h-0-3 bg-primary-black rounded-base"></span>
        <span className="block w-4-0 h-0-3 bg-primary-black rounded-base"></span>
        <span className="block w-4-0 h-0-3 bg-primary-black rounded-base"></span>
      </div>

      <div onClick={() => navigate('/')}>
        <Logo className="h-5-0" />
      </div>

      <div className="flex gap-3-0 items-center">
        <div className="p-2-0">
          <img src={accountIcon} />
        </div>
      </div>
      <HeaderCartButton />
    </nav>
  );
};

export default MobileNavigation;
